export default __webpack_public_path__ + "static/media/nutrition-icon-blue.459655be.svg";